import { Component, defineComponent, onMounted, onUnmounted } from 'vue';
import Spinner from '@/presentation/components/shared/spinner/spinner.vue';
import SearchResultItem
	from '@/presentation/components/organisation-linking/import-campaign-configuration-modal/search-result-item/search-result-item.vue';
import ImportCampaignConfigurationModalCode
	from '@/presentation/components/organisation-linking/import-campaign-configuration-modal/import-campaign-configuration-modal.code';

export default defineComponent({
	components: {
		Spinner: Spinner as Component,
		SearchResultItem: SearchResultItem as Component
	},
	setup: () => {
		const code = new ImportCampaignConfigurationModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			searchInput: code.searchInput,
			importButton: code.importButton,
			step: code.step,
			searchTerm: code.searchTerm,
			searchResults: code.searchResults,
			showSpinner: code.showSpinner,
			eligibility: code.eligibility,
			isValidatingEligibility: code.isValidatingEligibility,
			ineligibleMessage: code.ineligibleMessage,
			formattedSourceDateRange: code.formattedSourceDateRange,
			formattedDestinationDateRange: code.formattedDestinationDateRange,
			isImporting: code.isImporting,
			search: code.search.bind(code),
			selectCampaign: code.selectCampaign.bind(code),
			backToSearch: code.backToSearch.bind(code),
			confirmImport: code.confirmImport.bind(code)
		};
	}
});
